import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SubContext = createContext(null);
export const useSubscription = () => useContext(SubContext);

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paywall, setPaywall] = useState(null); // {feature} or null

  const refresh = useCallback(async () => {
    if (!user) {
      setSub(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/subscription/me");
      setSub(data);
    } catch (e) {
      console.error("Failed to load subscription:", e);
    }
    setLoading(false);
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const isPremium = !!sub?.is_premium;

  return (
    <SubContext.Provider value={{ sub, isPremium, loading, refresh, paywall, setPaywall }}>
      {children}
    </SubContext.Provider>
  );
}
